/**
 * Cart upsell facade: keep drawer HTML visible, load upsell CSS/JS when
 * the cart drawer opens. Does not delay add-to-cart, qty, or checkout.
 */
(() => {
  const root = document.querySelector("cart-upsells");
  if (!root) return;
  if (customElements.get("cart-upsells")) return;

  const loader = window.BoltFeatureLoader;
  const wrapper = root.closest("[data-facade-js]") || root;
  const assets = window.BoltAssets || {};
  const cssHref = assets.cartUpsellCss || wrapper.dataset.facadeCss;
  const jsSrc = assets.cartUpsell || wrapper.dataset.facadeJs;
  if (!loader || !jsSrc) return;

  let hydratePromise = null;

  const hydrate = () => {
    if (customElements.get("cart-upsells")) return Promise.resolve();
    if (hydratePromise) return hydratePromise;

    hydratePromise = Promise.all([
      cssHref ? loader.loadStylesheet(cssHref, "bolt-cart-upsell-css") : Promise.resolve(),
      loader.loadScript(jsSrc, "bolt-cart-upsell-js"),
    ])
      .then(() => customElements.whenDefined("cart-upsells"))
      .catch((error) => {
        hydratePromise = null;
        console.error("Cart upsell facade failed to load", error);
        throw error;
      });

    return hydratePromise;
  };

  const onDrawerOpen = (event) => {
    if (event.detail?.dialog?.id !== "cart-drawer") return;
    window.removeEventListener("dialog:open", onDrawerOpen);
    hydrate();
  };

  window.addEventListener("dialog:open", onDrawerOpen);
})();
